
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/timber/[slug]",
      function () {
        return require("private-next-pages/timber/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/timber/[slug]"])
      });
    }
  